module.exports = __webpack_public_path__ + "static/images/styles/images/reserves/additional-briefing.1bab5e0a.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/reserves/additional-briefing.png
// module id = 3692
// module chunks = 11